import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Box } from '@mui/material';
import { Tab, Tabs } from '../../Tabs';
function allProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const UploadTabs = ({ activeTabIdx, statuses, isLoading, handleTabStatus, }) => {
    return (_jsx(Box, Object.assign({ sx: { width: '100%', marginBottom: '24px' } }, { children: _jsx(Box, Object.assign({ sx: { borderBottom: 1, borderColor: 'divider' } }, { children: _jsx(Tabs, Object.assign({ value: activeTabIdx, onChange: (e, v) => handleTabStatus(v), indicatorColor: "secondary", "aria-label": "basic tabs example", sx: {
                    '& .MuiTab-root': {
                        textTransform: 'capitalize',
                    },
                } }, { children: statuses.map((status, index) => (_createElement(Tab, Object.assign({ disabled: isLoading, label: status }, allProps(index), { key: index })))) })) })) })));
};
export default UploadTabs;
